/**
 * Created by shubham on 20/4/18.
 */

import { Component, OnInit } from '@angular/core';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service';
import { APPCONFIG } from '../config';
import { MdDialog,MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogComponent, ShowApplicationsDialogComponent } from '../dialog/dialog.component';
import { TranslateService } from 'ng2-translate';
declare const gapi: any;

@Component({
    selector: 'my-profile',
    styles: [],
    template: require('./profile.component.html'),
    providers: []
})

export class ProfileComponent {
    dialogRef;
    userDetails:any;
    LanguageData:any;
    ProfileForm: FormGroup;
    ProfileFormDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isApplicationManager = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    data: any;
    profileData: any;
    responseLanguageId: any;
    flag: any;
    businessUnitsFlag: boolean = false;
    businessUnitWithApplicationAndRoles = [];
    businessUnitWithAppRolesProfile = [];

    constructor(private dialog: MdDialog, public httpService: HttpService, public sessionHandler: SessionHandler,
                private formBuilder: FormBuilder, private translate: TranslateService){
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        //Close Sidebar Initially
        APPCONFIG.navCollapsed = true;

        this.getLanguages();

        if(this.isSystemAdmin || this.isBUManager || this.isRegionalAdmin || this.isApplicationManager){
            if(this.isSystemAdmin){
                this.flag = 'systemAdmin';
            }
            if(this.isBUManager || this.isRegionalAdmin){
                this.flag = 'buManager';
            }
            if(this.isApplicationManager){
                this.flag = 'applicationManager';
            }
            this.profileData = this.userDetails;
            if(this.profileData.languageId){
                this.setLanguage(this.profileData.languageId);
            }
        }
        this.checkNotAdminRole(false, true);
    }

    public checkNotAdminRole(langFlag, getDataFlag){
        if(this.isServiceOwner || this.isTradePartner){
            this.flag = 'partners';
            if(getDataFlag){
                this.getPartnersProfileData(langFlag);
            }
        }
        if(this.isSubUser){
            this.flag = 'subUsers';
            if(getDataFlag){
                this.getSubUsersProfileData(langFlag);
            }
        }
    }

    //Get Languages Details
    public getLanguages(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.saveLanguageResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    //Save Languages Response
    public saveLanguageResponse(res) {
        if(res && res.items){
            this.LanguageData = res.items;
        }
        this.httpService.onEnd();
    }

    public getPartnersProfileData(langFlag){
        this.httpService.getRequest('partnerOperationsApi/v1/partnerDetails').subscribe(
            res => { this.savePartnersProfileData(res, langFlag) },
            err => { this.httpService.onEnd(); }
        );
    }

    public savePartnersProfileData(res, langFlag) {
        if(res){
            this.profileData = res;
            if(this.profileData){
                if(this.profileData.businessUnits){
                    this.businessUnitsFlag = true;
                }
                if(this.profileData.languageId){
                    this.setLanguage(this.profileData.languageId);
                }


                if(this.profileData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.profileData.businessUnitWithApplicationAndRoles;

                    for(let businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for(let appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']){
                            let temp = [];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];

                            let actionObject = {};
                            if( this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED' ){
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            } else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];

                            this.businessUnitWithAppRolesProfile.push(temp);
                        }
                    }
                }

                /*if(this.profileData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.profileData.businessUnitWithApplicationAndRoles;

                    for(let appIndex in this.businessUnitWithApplicationAndRoles){
                        if(!this.businessUnitWithApplicationAndRoles[appIndex]['message']){
                            this.businessUnitWithApplicationAndRoles[appIndex]['message'] = "";
                        }
                    }
                }*/
            }

            if(langFlag){
                this.setAppLanguage();
            }
            this.httpService.onEnd();
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    public getSubUsersProfileData(langFlag){
        this.httpService.getRequest('partnerOperationsApi/v1/companyUser').subscribe(
            res => { this.saveSubUsersProfileData(res, langFlag) },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveSubUsersProfileData(res, langFlag) {
        if(res){
            this.profileData = res;
            if(this.profileData){
                if(this.profileData.businessUnits){
                    this.businessUnitsFlag = true;
                }
                if(this.profileData.languageId){
                    this.setLanguage(this.profileData.languageId);
                }
            }
            if(langFlag){
                this.setAppLanguage();
            }
            this.httpService.onEnd();
        } else if(res.errorStatus == 'Fail'){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    public setLanguage(languageId){
        this.responseLanguageId = languageId;
        this.buildForm();
    }

    buildForm() {
        this.ProfileForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.responseLanguageId, [Validators.required])
        });
        this.ProfileForm.valueChanges.subscribe(data => {
            this.ProfileFormDetails = this.ProfileForm.getRawValue();
        });
    }

    public onLanguageChange(value: String){
        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.msg = 'lang_update_confirm';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(result => {
            if(result){
                this.httpService.postRequest(this.ProfileFormDetails,'userOperationsApi/v1/languageUpdate').subscribe(
                    res => { this.saveLnaguageChangeResponse(res); },
                    err => { this.httpService.onEnd(); }
                );
            } else{
                this.ProfileForm.controls['languageId'].setValue(this.responseLanguageId);
            }
        });
    }

    public saveLnaguageChangeResponse(res){
        this.httpService.onEnd();
        if(res) {
            this.profileData = res;
            this.setLanguage(this.profileData.languageId);
            this.sessionHandler.saveItem("loginData", JSON.stringify(res));
            this.setAppLanguage();
            if(this.isServiceOwner || this.isTradePartner || this.isSubUser) {
                this.checkNotAdminRole(true, false);
            }
        }
    }

    public setAppLanguage(){
        this.sessionHandler.saveItem("languageId", this.profileData.languageId);
        this.translate.setDefaultLang(this.profileData.languageId);
        this.translate.use(this.profileData.languageId);

        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.msg = "lang_update_success";
    }

    selectedOption;
    public performAction(action){
        this.dialogRef = this.dialog.open(EmailPasswordActionDialogComponent);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.currentEmailAddress = this.profileData.email;
        this.dialogRef.componentInstance.userId = this.userDetails.id;
        this.dialogRef.componentInstance.userDetails = this.userDetails;
        this.dialogRef.afterClosed().subscribe(result => {
            this.data = result;
        });
    }

    setProfileAction(action, profileFormData){
        this.dialog.closeAll();
        if(action == 'changeEmail'){
            this.httpService.postRequest(profileFormData,'userOperationsApi/v1/selfEmailUpdate').subscribe(
                res => { this.saveResponse(res, 'changeEmail'); },
                err => { this.httpService.onEnd(); }
            );
        } else if(action == 'changePassword'){
            this.httpService.postRequest(profileFormData,'userOperationsApi/v1/changePassword').subscribe(
                res => { this.saveResponse(res, 'changePassword'); },
                err => { this.httpService.onEnd(); }
            );
        }
    }
    public saveResponse(res, action){
        this.httpService.onEnd();
        if(res){
            if(action == 'changePassword'){
                this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = 'Password updated successfully';
            } else if(action == 'changeEmail'){
                this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = 'account_update_request_notify';
            }
        }
    }

    showApplicationsWithRoles(apps){
        this.dialogRef = this.dialog.open(ShowApplicationsDialogComponent);
        for(let appIndex in apps){
            if(!apps[appIndex]['message']){
                apps[appIndex]['message'] = "";
            }
        }
        this.dialogRef.componentInstance.apps = apps;
        this.dialogRef.componentInstance.profileFlag = true;
    }

    ngOnInit(): void {
        this.buildForm();
    }
}

@Component({
    providers:[ProfileComponent],
    template: require('./emailPasswordActionDialogComponent.html')
})
export class EmailPasswordActionDialogComponent implements OnInit {
    currentEmailAddress: any;
    action: any;
    userId: any;
    userDetails: any;
    changeEmail: any;
    changePass: any;
    ProfileActionForm: FormGroup;
    profileEmailDetails: any;
    profilePasswordDetails: any;
    emailPattern = APPCONFIG.emailPattern;
    //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    // passwordPattern = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{5,}$/;
    passwordPattern = /^(?=[A-Za-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/])[A-Za-z0-9~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/]{16,40}$/;
    passwordErrorMsg: string = '';

    constructor(public dialog: MdDialog, public dialogRef: MdDialogRef<DialogComponent>, private formBuilder: FormBuilder, private profileComponent: ProfileComponent) {
        this.changeEmail = 'changeEmail';
        this.changePass = 'changePassword';
        
    }

    buildForm() {
        this.ProfileActionForm = this.formBuilder.group({
            emailGroup: this.formBuilder.group({
                currentEmailAddress: this.formBuilder.control({value: this.currentEmailAddress, disabled: true}, [Validators.required, Validators.pattern(this.emailPattern)]),
                email: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)]),
                confirmEmail: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.emailPattern)])
            },{validator: this.checkEmail}),
            passwordGroup: this.formBuilder.group({
                currentPassword: this.formBuilder.control(null, [Validators.required]),
                // password: this.formBuilder.control(null, [Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern(this.passwordPattern)]),
                password: this.formBuilder.control('', [
  Validators.required,
  Validators.minLength(16),
  Validators.maxLength(40),
  Validators.pattern(this.passwordPattern),
  this.noPersonalInfoValidator.bind(this)
]),
                confirmPassword: this.formBuilder.control(null, [Validators.required, Validators.pattern(this.passwordPattern)])
            },{validator: this.checkPassword})
        });
        this.ProfileActionForm.valueChanges.subscribe(data => {
            let profileDetails = this.ProfileActionForm.getRawValue();
            this.profileEmailDetails =  profileDetails.emailGroup;
            this.profileEmailDetails['id'] = this.userId;
            this.profilePasswordDetails =  profileDetails.passwordGroup;
        });

        // this.ProfileActionForm.get('passwordGroup').get('password').valueChanges.subscribe(data=> {
        //     if(data != null && data != ""){
        //         this.ProfileActionForm.get('passwordGroup').get('password').setErrors({'incorrect': true});
        //         if(!/.*[A-Z]/.test(data) || !/.*[a-z]/.test(data)){
        //             this.passwordErrorMsg = "pass_one_upper_lower_char";
        //         } else if(!/.*[0-9]/.test(data)){
        //             this.passwordErrorMsg = "pass_one_number";
        //         } else if(data.length != 8){
        //             this.passwordErrorMsg = "pass_8_chars";
        //         } else if(data.toLowerCase().includes(this.userDetails.userId_WPASS.toLowerCase())){
        //             this.passwordErrorMsg = "pass_no_userId";
        //         } else{
        //             this.passwordErrorMsg = "";
        //             this.ProfileActionForm.get('passwordGroup').get('password').setErrors(null);
        //         }
        //     }
        // })
         this.ProfileActionForm.get('passwordGroup').get('password').valueChanges.subscribe(data => {
        if (!data) return;
        if (data.length < 16 || data.length > 40) {
            this.passwordErrorMsg = "Minimum of 16 characters and maximum of 40 characters long";
        } else if (!/^[A-Za-z]/.test(data)) {
            this.passwordErrorMsg = "First character must be an alphabet";
        } else if (!/[A-Z]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one uppercase character (A–Z)";
        } else if (!/[a-z]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one lowercase character (a–z)";
        } else if (!/[0-9]/.test(data)) {
            this.passwordErrorMsg = "Contain at least one numeric character (0–9)";
        } else if (!/[~@$%^&*_\-+‘|=(){}\[\]:;‘"\\<>,.\/]/.test(data)) {
            this.passwordErrorMsg =   'Contain at least one special character (~ @ $ % ^ & * _ - + | = ( ) { } [ ] : ; " \\ < > , . /)';
        } else if ( this.ProfileActionForm.get('passwordGroup').get('password').hasError('personalInfo')) {
            this.passwordErrorMsg = "Should not contain your first name, last name, or user id";
        } else {
            this.passwordErrorMsg = "";
        }
    });
        
    }

    noPersonalInfoValidator(control: any) {
        
  if (!control || !control.value) return null;
 
  var password = control.value.toLowerCase();
 
  var profile = this.profileComponent.profileData;
  if (!profile) return null;
 
  var firstName = profile.firstName
      ? profile.firstName.toLowerCase()
      : '';
 console.log(firstName +"fssd");
  var lastName = profile.lastName
      ? profile.lastName.toLowerCase()
      : '';
 
  var email = profile.email
      ? profile.email.toLowerCase()
      : '';
 
  var emailUser = email.indexOf('@') > -1 ? email.split('@')[0] : '';
 
  if (
      (firstName && password.indexOf(firstName) > -1) ||
      (lastName && password.indexOf(lastName) > -1) ||
      (emailUser && password.indexOf(emailUser) > -1)
  ) {
      return { personalInfo: true };
  }
 
  return null;
}

    checkEmail(group: FormGroup) {
        if(group.get('email').value === group.get('confirmEmail').value){
            return null;
        } else{
            group.get('confirmEmail').setErrors({'incorrect': true});
            return {'mismatch': true};
        }
    }

    checkPassword(group: FormGroup) {
        if(group.get('password').value === group.get('confirmPassword').value){
            group.get('confirmPassword').setErrors(null);
            return null;
        } else{
            group.get('confirmPassword').setErrors({'incorrect': true});
            return {'mismatch': true};
        }
    }

    showPassword(input: any): any {
        input.type = input.type === 'password' ?  'text' : 'password';
    }

    ngOnInit(): void {
        this.buildForm();
    }

    changeEmailAddress() {
        this.profileComponent.setProfileAction(this.changeEmail, this.profileEmailDetails);
    }

    changePassword() {
        this.profileComponent.setProfileAction(this.changePass, this.profilePasswordDetails);
    }

    public closeDialog(){
        this.dialog.closeAll();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/profile/profile.component.ts